interface ExperienceCardProps {
  client: string;
  project: string;
  scope: string;
  capabilities: string[];
  technologies: string[];
  location?: string;
  country?: string;
  roleLabel?: string;
  icon?: string;
}

export default function ExperienceCard({
  client,
  project,
  scope,
  capabilities,
  technologies,
  location,
  country,
  roleLabel = "Subcontractor",
  icon = "ri-briefcase-line",
}: ExperienceCardProps) {
  return (
    <article className="card-base overflow-hidden">
      <div className="h-1.5 bg-gradient-to-r from-primary-700 via-primary-500 to-accent-500"></div>
      <div className="p-6 md:p-8">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 mb-5">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-lg bg-primary-50 flex items-center justify-center shrink-0">
              <i className={`${icon} text-primary-600 text-lg`}></i>
            </div>
            <div>
              <h3 className="text-lg font-bold text-foreground-950 tracking-tight">
                {client}
              </h3>
              {(location || country) && (
                <p className="text-xs text-foreground-500 mt-0.5">
                  {[country, location].filter(Boolean).join(" · ")}
                </p>
              )}
            </div>
          </div>
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider px-3 py-1.5 rounded-full bg-accent-50 text-accent-800 border border-accent-200 shrink-0">
            <i className="ri-contract-line"></i>
            Mitaja Role: {roleLabel}
          </span>
        </div>

        <div className="mb-4">
          <h4 className="text-base font-bold text-foreground-900 leading-snug">
            {project}
          </h4>
        </div>

        <p className="text-sm text-foreground-600 leading-relaxed mb-6">
          {scope}
        </p>

        <div className="mb-4">
          <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-2">
            Capabilities
          </p>
          <div className="flex flex-wrap gap-2">
            {capabilities.map((tag) => (
              <span
                key={tag}
                className="text-xs px-2.5 py-1 rounded-full bg-secondary-50 text-secondary-800 font-medium border border-secondary-100"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>

        <div>
          <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-2">
            Technologies
          </p>
          <div className="flex flex-wrap gap-2">
            {technologies.map((tag) => (
              <span
                key={tag}
                className="text-xs px-2.5 py-1 rounded-full bg-white text-primary-700 font-medium border border-primary-100"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </article>
  );
}